import React from "react";
import { AreaMapContext } from "../context";

export const useMapManager = () => {
  const values = React.useContext(AreaMapContext);
  return values;
};
